<div class="container-full">

    <div class="row" style="margin-left:0px;">
        <div class="col-12 text-center">
            <mat-button-toggle-group name="fontStyle" aria-label="Chart Style" value="qty">
                <mat-button-toggle value="qty" (click)="onSetDataSeriesQuantity()">
                    <span style="font-size:18px;" class="ace-heading-text-secondary">Qty</span>
                </mat-button-toggle>
                <mat-button-toggle value="amount" (click)="onSetDataSeriesAmount()">
                    <span style="font-size:18px;" class="ace-heading-text-secondary">Amount</span>
                </mat-button-toggle>
              </mat-button-toggle-group>
              <br />
              <div style="margin-top:10px;">
              <span style="font-size:18px;" class="ace-heading-text-secondary">Aging</span>
            </div>
        </div>
       
    </div>

    <div class="row" style="margin-left:20px;">
        <div class="col-12">
            <!-- <igx-data-chart #chart width="100%" height="100%" [dataSource]="data" [legend]="legend">
            </igx-data-chart> -->

        </div>
    </div>
   
</div>

<!-- <div class="container"> -->
    <!-- <div style="width:400px;height:400px;">
    <igx-data-chart #chart width="100%" height="100%" [dataSource]="data" [legend]="legend" style="margin-left:30px;margin-top:20px;">
    </igx-data-chart>
</div> -->
    
<!-- </div> -->
<div class="container-full">
    <div class="row">
        <div class="col-11">
            <div style="width:100%;height:152px;">
                <igx-data-chart #chart width="100%" height="100%" [dataSource]="chartData" [legend]="legend" style="margin-left:30px;margin-top:20px;">
                </igx-data-chart>
            </div>    
        </div>
        <div class="col-1">
        </div>
        <div class="col-12">
            <igx-legend #legend orientation="horizontal"></igx-legend>
        </div>
    </div>
</div>
